const RELEASE_TIME_NAVS = [
  "通知公告",
  "国内动态",
  "国际动态",
  "竞赛规则",
  "竞赛信息",
  "赛事现场",
];

export function getArticlePublishTime(item, navigationName) {
  if (!item) return "";
  if (RELEASE_TIME_NAVS.includes(navigationName)) {
    return item.releaseTime || item.createTime;
  }
  return item.createTime;
}
